import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./custom.datepicker.modal.css";
import "../../App.css";
import picClose from "../../images/close.svg";
import { QuestionCircleOutlined } from "@ant-design/icons";

const MODAL_CONTAINER_ID = "modal-container-date-picker";

export const CustomDatepickerModal = ({onClose, title, children, onShowHelpContext}) => {
    const rootRef = useRef(null);
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        createContainer({ id: MODAL_CONTAINER_ID });
        setMounted(true);
      }, []);   
      
      useEffect(() => {
        const handleWrapperClick = (event) => {
          const { target } = event;
    
          if (target instanceof Node && rootRef.current === target) {
            onClose?.( false );            
          }
        };
        const handleEscapePress = (event) => {
          if (event.key === "Escape") {
            onClose?.( false );
          }
        };
    
        window.addEventListener("click", handleWrapperClick);
        window.addEventListener("keydown", handleEscapePress);
    
        return () => {
          window.removeEventListener("click", handleWrapperClick);
          window.removeEventListener("keydown", handleEscapePress);
        };
      }, [onClose]);      

    const handleClose = useCallback(() => {
        onClose?.( false );
    }, [onClose]);      

    return isMounted ? (
    <Portal id={MODAL_CONTAINER_ID} className="modal-window">

        <div className="wrap-modal no-draggable" ref={rootRef}>
        <div className="content-modal">            
            <div className="title-modal">
                <span className="custom-datepicker-help-icon help-icon" onClick={onShowHelpContext}><QuestionCircleOutlined /></span>
                <img src={picClose} onClick={handleClose} className="closeButton-modal" />                
                {title}
            </div>
            {children}
        </div>
        </div>        
    </Portal>
    ) : null;  
}

const createContainer = (options) => {
  if (document.getElementById(options.id)) {
    return;
  }

  const portalContainer = document.createElement("div");
  portalContainer.setAttribute("id", options.id);
  document.body.appendChild(portalContainer);
};

const PORTAL_ERROR_MSG = `There is no portal container in markup. Please add portal container with proper id attribute.`;

const Portal = ({id, children}) => {
  const [container, setContainer] = useState();

  useEffect(() => {
    if (id) {
      const portalContainer = document.getElementById(id);

      if (!portalContainer) {
        throw new Error(PORTAL_ERROR_MSG);
      }

      setContainer(portalContainer);
    }
  }, [id]);

  return container ? createPortal(children, container) : null;
};